import React, { useState, useRef, useEffect } from "react";
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./../utils/Style/common.scss";
import { useNavigate } from "react-router-dom";
import UtcToLocal from "./UtcToLocal";
import EmptyTransactionsMessage from "./EmptyTransactionsMessage";

const TableSelect = (props) => {
    const componentRef = useRef(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const handleRowClick = (row) => {
        props.setAmountDetails(row.original.Transaction)
        props.setVisible(true)
        props.setActiveRowIndex(row.index);
    };

    useEffect(() => {
        window.addEventListener("resize", () => setScreenWidth(window.innerWidth));
        return () => window.removeEventListener("resize", () => setScreenWidth(window.innerWidth));
    }, []);

    return (
        <>
            {screenWidth < 768 ? (
                <div id="table-container-mobile" ref={componentRef}>
                    {props.headerGroups.map((headerGroup) => (
                        <div {...headerGroup.getHeaderGroupProps()} className="theader">
                            {headerGroup.headers.map((column) => (
                                <div {...column.getHeaderProps()} className="eachone">
                                    {column.render("Header")}
                                </div>
                            ))}
                        </div>
                    ))}
                    {props.page.map((row) => {
                        props.prepareRow(row);
                        const isActive = props.activeRowIndex === row.index;

                        return (
                            <div {...row.getRowProps()} className={` tbody ${isActive ? "tractive" : ""}`}>
                                {isActive ? <button className="showmoreactive" onClick={() => { props.setActiveRowIndex(-1) }}><FontAwesomeIcon icon={faArrowUp} /></button>
                                    : <></>}

                                {row.cells.map((cell) => (
                                    <div {...cell.getCellProps()} className={`eachone ${isActive ? "tdactive" : ""}`}>
                                        {cell.render("Cell")}
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div id="table-container" className={props.activeRowIndex === -1 ? "" : " usdTableSelect"} ref={componentRef}>
                    <table {...props.getTableProps()} className="AllTable">
                        <thead>
                            {props.headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>
                                            {column.render("Header")}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        {

                        }
                        <tbody {...props.getTableBodyProps()}>
                            {props.page.map((row) => {
                                props.prepareRow(row);
                                const isActive = props.activeRowIndex === row.index;

                                return (
                                    <tr
                                        {...row.getRowProps()}
                                        className={isActive ? "tractive" : ""}
                                    >
                                        {row.cells.map((cell) => (
                                            <td
                                                {...cell.getCellProps()}
                                                className={isActive ? "tdactive" : ""}
                                                onClick={() => {
                                                    const key=cell.getCellProps().key.toString();
                                                    if (!key.includes("Action")) {
                                                        handleRowClick(row);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })}

                        </tbody>
                    </table>
                    <>
                        {
                            props.totalNbPage === 0 &&
                            <EmptyTransactionsMessage/>
                        }
                    </>
                </div>
            )}
        </>
    );
}

export default TableSelect;
